import * as HttpService from './http.service';
import {
    CREATE_COMMAND_HISTORY,
    GET_COMMAND_HISTORY,
    TOGGLE_COMMAND_FAVOURITE
} from './url.service';

// Persists one command execution. Fire-and-forget from the caller's view —
// must never block command rendering.
export const captureCommand = (payload) => HttpService.postWithAuth(CREATE_COMMAND_HISTORY(), payload);

// Loads the user's full command history (Recent + Favourites derived from it).
export const getCommandHistory = () => HttpService.getWithAuth(GET_COMMAND_HISTORY());

// Adds/removes a favourite, keyed by command + curve + structure.
export const toggleFavourite = ({
    command, curve, structure, isFavourite
}) => HttpService.postWithAuth(TOGGLE_COMMAND_FAVOURITE(), {
    command, curve, structure, isFavourite
});
